export default "__VITE_ASSET__DkFtDwb$__"